import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取订单数量角标
  static getOrderCount() {
    return request({
      url: 'tradecore/order/home/order-count',
      host: config.HOST_MALL
    });
  }

  // 用户公益信息查询
  static getUserDonateInfo() {
    return request({
      url: `donate/info`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  // 获取是否显示肽素乳畅享卡
  static getShowBatchOrder() {
    return request({
      url: `user/info/showBatchOrder`,
      host: config.HOST_MALL,
      method: 'POST'
    });
  }

  // 获取拼团订单
  // static getMyGroupOrderOrderList(params) {
  //   return request({
  //     url: 'tradecore/order/my-group-order/list-by-page',
  //     host: config.HOST_MALL,
  //     method: 'post_json',
  //     data: params,
  //   });
  // }

  // getUserCardLevel 新站点
  static getUserCardLevel() {
    return request({
      url: 'member/info/get',
      host: config.HOST_PROMOTE
    });
  }

  // 获取消息数量角标
  static getMsgCount(params) {
    return request({
      url: 'message/queryNoReadMessageCount',
      host: config.HOST_MALL,
      ignore401: true
    });
  }

  // 查询是否可开实体卡或虚拟卡
  static queryCanApplyType(params) {
    return request({
      url: 'user/register/checkOpenCardAttribute',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否有未付款的升级订单
   */
  static queryCanUpgrade(ignoreToast) {
    return request({
      url: 'user/upgrade/checkHasUpgradeOrder',
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreToast
    });
  }

  /**
   * 查询是否会员信息不全
   */
  static checkMsgIsFull(cardCode) {
    return request({
      url: `user/upgrade/checkUpgradeCompletionInfor/${cardCode}`,
      host: config.HOST_MALL
    });
  }

  // 升级 - 查询卡类型
  static queryCardType(params) {
    return request({
      url: 'user/upgrade/queryCardType',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取各种优惠券数量
   */
  static getCouponCount(params) {
    return request({
      url: `coupon/count`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  //判断是否有合利共盈的权限
  static isShopAuthority() {
    return request({
      url: `mutual/isShopAuthority`,
      host: config.HOST_MALL,
      method: 'get',
      data: {}
    });
  }

  // 查询会员证件列表
  static queryCertificateList() {
    return request({
      url: `personal/queryMemberCertificate`,
      host: config.HOST_MALL
    });
  }

  /**
   * 当前主卡用户是否绑定了权益共享卡用户 0不是 1是
   */
  static getEquityBindRelationByMaster() {
    return request({
      url: 'equityCard/getEquityBindRelationByMaster',
      host: config.HOST_MALL
    });
  }

  /**
   * 当前用户是否权益共享卡用户 0不是 1是
   */
  static getEquityBindRelationByUserId() {
    return request({
      url: 'equityCard/getEquityBindRelationByUserId',
      host: config.HOST_MALL
    });
  }

  /**
   * 获取用户信息
   */
  static getUserInfo() {
    return request({
      url: 'member/info/get',
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 获取生日信息
   */
  static fetchBirthdayInfo() {
    return request({
      url: 'content/homePageAdUi',
      host: config.HOST_MALL,
      method: 'get'
    });
  }
  /**
   * 获取是否显示完善资料
   */
  static getUserShouldSupply() {
    return request({
      url: 'user/info/getUserShouldSupply',
      host: config.HOST_MALL,
      method: 'get'
    });
  }
  /**
   * 获取海报信息
   */
  static getPosterNo(posterNo) {
    return request({
      url: `content/poster/queryByPosterNo/${posterNo}`,
      host: config.HOST_PROMOTE
    });
  }
  /**
   * 是否可以根据海报编号查询分享的选择卡号列表(销售顾问)
   */
  static getSupportQueryShareCardCodesByPosterNo(posterNo) {
    return request({
      url: `content/poster/supportQueryShareCardCodesByPosterNo/${posterNo}`,
      host: config.HOST_PROMOTE
    });
  }
  /**
   * 根据海报编号查询分享的选择卡号列表(销售顾问)
   */
  static getShareCardCodesByPosterNo(posterNo) {
    return request({
      url: `content/poster/queryShareCardCodeListByPosterNo/${posterNo}`,
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 极萃分享海报二维码
   */
  static generateQRCode(params) {
    return request({
      url: 'user/info/generateQRCode',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 检验卡号是否有效
   */
  static verifyMemberCardValid(params) {
    return request({
      url: 'store/create/checkMemberCardValid',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取申请结果内容
   */
  static queryStoreAuditDetail(params) {
    return request({
      url: 'store/audit/queryStoreAuditDetail',
      host: config.HOST_STORE,
      method: 'post_json'
    });
  }

  /**
    验证是否允许升级：cardCode（会员卡号），自主升级时cardCode参数可以不传，代客需要传被代人会员卡号
   */
  static queryVerifyUpgrade(cardCode) {
    return request({
      url: `user/upgrade/verifyUpgrade?cardCode=${cardCode}`,
      host: config.HOST_MALL,
      method: 'get'
      // returnAll: true,
    });
  }

  /**
   * 获取工作室类型列表
   */
  static getStoreTypeList(params) {
    return request({
      url: `store_type/list`,
      host: config.HOST_STORE,
      params
    });
  }

  /**
   * 获取体系区域配置情况
   */
  static getRegionConfiguration(params) {
    return request({
      url: `store_type/validate/occupancy`,
      host: config.HOST_STORE,
      params,
      method: 'post'
    });
  }

  // 头等舱详情
  static queryFirstClassInfo() {
    return request({
      url: 'trade/query/firstClass/info',
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  // 获取我的常用
  static getMyUsual() {
    return request({
      url: `user/info/getMyUsual`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  // 添加至我的常用
  static setMyUsual(data) {
    return request({
      url: `user/info/setMyUsual`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  static getShowQuest() {
    return request({
      url: `survey/quest/checkShowQuest`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  // 获取推荐产品列表
  static getRecommendProductList(params, data) {
    return request({
      url: 'es/item/query/browse/page-info',
      host: config.HOST_SEARCH,
      method: 'post_json',
      params,
      data
    });
  }

  // 云连锁详情
  static getDetailByUserIdAndType(params) {
    return request({
      url: 'chain/online/getDetailByUserIdAndType',
      host: config.HOST_MALL,
      params
    });
  }

  // 获取推荐位店铺信息
  static getStoreInfo() {
    return request({
      url: 'content/recommandUi/storeInfo/1/2',
      host: config.HOST_MALL
    });
  }

  // 是否有实体店认证的入口
  static getIndividualPurview() {
    return request({
      url: 'third/individual/purview',
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/PersonalServ.js